"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Root = exports.classes = void 0;
const styles_1 = require("@mui/material/styles");
const PREFIX = "Section";
exports.classes = {
    nonDialog: `${PREFIX}-root`,
    overflowVisible: `${PREFIX}-overflowVisible`,
    alabaster: `${PREFIX}-alabaster`,
    pearl: `${PREFIX}-pearl`,
    white: `${PREFIX}-white`,
    noSpacing: `${PREFIX}-noSpacing`,
    slim: `${PREFIX}-slim`
};
exports.Root = (0, styles_1.styled)("div")(({ theme }) => ({
    [`&.${exports.classes.nonDialog}`]: {
        padding: "30px 0",
        backgroundColor: "transparent",
        overflow: "hidden"
    },
    [`&.${exports.classes.overflowVisible}`]: {
        overflow: "visible"
    },
    [`&.${exports.classes.alabaster}`]: {
        backgroundColor: theme.colours.alabaster
    },
    [`&.${exports.classes.pearl}`]: {
        backgroundColor: theme.colours.pearl
    },
    [`&.${exports.classes.white}`]: {
        backgroundColor: theme.colours.white
    },
    [`&.${exports.classes.noSpacing}`]: {
        padding: 0
    },
    [`&.${exports.classes.slim}`]: {
        padding: "32px 0"
    }
}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic3R5bGVzLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL3NlY3Rpb24vc3R5bGVzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUFBLGlEQUE4QztBQUU5QyxNQUFNLE1BQU0sR0FBRyxTQUFTLENBQUM7QUFFWixRQUFBLE9BQU8sR0FBRztJQUNyQixTQUFTLEVBQUUsR0FBRyxNQUFNLE9BQU87SUFDM0IsZUFBZSxFQUFFLEdBQUcsTUFBTSxrQkFBa0I7SUFDNUMsU0FBUyxFQUFFLEdBQUcsTUFBTSxZQUFZO0lBQ2hDLEtBQUssRUFBRSxHQUFHLE1BQU0sUUFBUTtJQUN4QixLQUFLLEVBQUUsR0FBRyxNQUFNLFFBQVE7SUFDeEIsU0FBUyxFQUFFLEdBQUcsTUFBTSxZQUFZO0lBQ2hDLElBQUksRUFBRSxHQUFHLE1BQU0sT0FBTztDQUN2QixDQUFDO0FBRVcsUUFBQSxJQUFJLEdBQUcsSUFBQSxlQUFNLEVBQUMsS0FBSyxDQUFDLENBQUMsQ0FBQyxFQUFFLEtBQUssRUFBRSxFQUFFLEVBQUUsQ0FBQyxDQUFDO0lBQ2hELENBQUMsS0FBSyxlQUFPLENBQUMsU0FBUyxFQUFFLENBQUMsRUFBRTtRQUMxQixPQUFPLEVBQUUsUUFBUTtRQUNqQixlQUFlLEVBQUUsYUFBYTtRQUM5QixRQUFRLEVBQUUsUUFBUTtLQUNuQjtJQUNELENBQUMsS0FBSyxlQUFPLENBQUMsZUFBZSxFQUFFLENBQUMsRUFBRTtRQUNoQyxRQUFRLEVBQUUsU0FBUztLQUNwQjtJQUNELENBQUMsS0FBSyxlQUFPLENBQUMsU0FBUyxFQUFFLENBQUMsRUFBRTtRQUMxQixlQUFlLEVBQUUsS0FBSyxDQUFDLE9BQU8sQ0FBQyxTQUFTO0tBQ3pDO0lBQ0QsQ0FBQyxLQUFLLGVBQU8sQ0FBQyxLQUFLLEVBQUUsQ0FBQyxFQUFFO1FBQ3RCLGVBQWUsRUFBRSxLQUFLLENBQUMsT0FBTyxDQUFDLEtBQUs7S0FDckM7SUFDRCxDQUFDLEtBQUssZUFBTyxDQUFDLEtBQUssRUFBRSxDQUFDLEVBQUU7UUFDdEIsZUFBZSxFQUFFLEtBQUssQ0FBQyxPQUFPLENBQUMsS0FBSztLQUNyQztJQUNELENBQUMsS0FBSyxlQUFPLENBQUMsU0FBUyxFQUFFLENBQUMsRUFBRTtRQUMxQixPQUFPLEVBQUUsQ0FBQztLQUNYO0lBQ0QsQ0FBQyxLQUFLLGVBQU8sQ0FBQyxJQUFJLEVBQUUsQ0FBQyxFQUFFO1FBQ3JCLE9BQU8sRUFBRSxRQUFRO0tBQ2xCO0NBQ0YsQ0FBQyxDQUFDLENBQUMifQ==